<template>
  <div>
    <el-date-picker
      type="datetimerange"
      size="small"
      range-separator="~"
      v-model="formTime"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00', '23:59:59']"
    />
    <el-button
      size="mini"
      type="primary"
      v-for="(btn, key) in btnsTime"
      :key="key + Date.now()"
      @click="handleTime(key)"
      round
      >{{ btn }}
    </el-button>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'rangeDatePicker',
  props: {
    needInit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      formTime: null,
      formatStr: Object.freeze('YYYY-MM-DD HH:mm:ss'),
      yesterday: 0,
      lastMonth: 0,
      tomorrow: 0
    };
  },
  computed: {
    btnsTime() {
      return this.$t('orders.btns');
    }
  },
  watch: {
    needInit: {
      handler(val) {
        if (val) {
          this.formTime = [
            dayjs().startOf('day').format(this.formatStr),
            dayjs().endOf('day').format(this.formatStr)
          ];
          this.$emit('showDateTime', this.formTime);
        }
      },
      immediate: true
    },
    formTime(val) {
      if (!val || !val.length) {
        this.$emit('showDateTime', []);
      } else {
        this.$emit('showDateTime', val);
      }
    }
  },

  created() {
    // this.init();
  },
  mounted() {
    this.resetTime();
  },
  methods: {
    timestamp(time) {
      return dayjs(time).format(this.formatStr);
    },
    /* ---------------------------------- 改变时间 ---------------------------------- */
    handleTime(type = '') {
      switch (type) {
        case 'today':
          this.resetTime();
          this.formTime = [
            dayjs().startOf('day').format(this.formatStr),
            dayjs().endOf('day').format(this.formatStr)
          ];
          break;
        case 'yesterday':
          this.yesterday++;
          this.formTime = [
            dayjs(this.formTime ? this.formTime[0] : Date.now()).subtract(1, 'days').startOf('day').format(this.formatStr),
            dayjs(this.formTime ? this.formTime[0] : Date.now()).subtract(1, 'days').endOf('day').format(this.formatStr)
          ];
          break;
        case 'tomorrow':
          // this.resetTime();
          this.tomorrow++;
          this.formTime = [
            dayjs(this.formTime ? this.formTime[0] : Date.now()).add(1, 'days').startOf('day').format(this.formatStr),
            dayjs(this.formTime ? this.formTime[0] : Date.now()).add(1, 'days').endOf('day').format(this.formatStr)
          ];
          break;
        case 'month':
          this.resetTime();
          this.formTime = [
            dayjs().startOf('month').format(this.formatStr),
            dayjs().endOf('day').format(this.formatStr)
          ];
          break;
        case 'lastMonth':
          this.lastMonth++;
          this.formTime = [
            dayjs().subtract(this.lastMonth, 'months').startOf('month').format(this.formatStr),
            dayjs().subtract(this.lastMonth, 'months').endOf('month').format(this.formatStr)
          ];
          break;
        default:
          this.resetTime();
          this.formTime = [];
          break;
      }
    },
    resetTime() {
      this.tomorrow = 0;
      this.yesterday = 0;
      this.lastMonth = 0;
    },
    banTime2() {
      return {
        // disabledDate: (time) => {
        //   const zeroTime =
        //     new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
        //   // return Number(time) > Date.now() - 8.64e7;
        //   if (this.time.start) {
        //     // 限制最多选30天记录
        //     const date = new Date(this.time.start);
        //     // console.log('🚀 ~ file: v-date-picker.vue ~ line 174 ~ banTime2 ~ date', date);
        //     const Y = date.getFullYear();
        //     const M = date.getMonth();
        //     // 当月最后一天为下个月的第0天，
        //     const d = new Date(Y, M + 1, 0);
        //     const t = d.getDate();
        //     const _time = 60 * 60 * 24 * t * 1000;
        //     // Number(time) > Number(this.time.start) ||

        //     return Number(time) < Number(date) || Number(time) > zeroTime;
        //   } else {
        //     return Number(time) > zeroTime;
        //   }
        // }
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/cuscom/range-date-picker.vue